class Config {
    /**
     * A boolean dictating whether platform-level "native" focus should be used.
     *
     * @default false
     */

    public useNativeFocus: boolean = false;

    /**
     * A number in milliseconds, dictating any throttling to be applied to all focusable containers,
     * unless overridden.
     *
     * @default 0
     */

    public throttleDurationMs: number = 0;

    /**
     * A boolean dictating whether scrolling should be prevented when a DOM element receives native
     * focus via the focus manager.
     *
     * Only applicable if in a DOM environment, and `useNativeFocus` is set.
     *
     * @default false
     */

    public preventScroll: boolean = false;

    /**
     * A boolean dictating whether a focusable node should gain and lose focus when a mouse or
     * pointer enters and leaves its focusable DOM element.
     *
     * @default false
     */

    public focusOnHover: boolean = false;

    /**
     * A boolean dictating whether a `SELECT` event should be dispatched from a focusable node when
     * its focusable DOM element is clicked (e.g. by a mouse or pointer).
     *
     * @default false
     */

    public selectOnClick: boolean = false;
}

export default Config;
